import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-83adcb16")

_pushScopeId("data-v-83adcb16")
const _hoisted_1 = { class: "fridgesettingstime-page" }
const _hoisted_2 = { class: "fridgesettingstime-page-top" }
const _hoisted_3 = { class: "fridgesettingstime-page-top-title" }
const _hoisted_4 = { class: "fridgesettingstime-page-top-title-text" }
const _hoisted_5 = { class: "fridgesettingstime-page-top-input" }
const _hoisted_6 = { class: "fridgesettingstime-page-content" }
const _hoisted_7 = { class: "fridgesettingstime-page-content-itemname" }
const _hoisted_8 = { class: "fridgesettingstime-page-content-itemname-text" }
const _hoisted_9 = { class: "fridgesettingstime-page-content-description" }
const _hoisted_10 = { class: "fridgesettingstime-page-content-description-mode" }
const _hoisted_11 = { class: "fridgesettingstime-page-content-description-mode-text" }
const _hoisted_12 = { class: "fridgesettingstime-page-content-description-pushcount" }
const _hoisted_13 = { class: "fridgesettingstime-page-content-description-pushcount-text" }
const _hoisted_14 = { class: "fridgesettingstime-page-content-optime" }
const _hoisted_15 = { class: "fridgesettingstime-page-content-optime-text" }
const _hoisted_16 = { class: "fridgesettingstime-page-content-picker" }
const _hoisted_17 = { class: "fridgesettingstime-page-content-picker-content" }
const _hoisted_18 = { class: "fridgesettingstime-page-bottom" }
const _hoisted_19 = { class: "fridgesettingstime-page-bottom-button-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FridgeDetailsDrumPicker = _resolveComponent("FridgeDetailsDrumPicker")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.listTitleText), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("input", {
          type: "text",
          ref: "textInput",
          class: "fridgesettingstime-page-top-input-form",
          maxlength: _ctx.textMaxLength,
          value: _ctx.currentName
        }, null, 8, ["maxlength", "value"])
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("span", _hoisted_8, _toDisplayString(_ctx.operationModeText), 1)
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.modeText), 1)
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("span", _hoisted_13, _toDisplayString(_ctx.pushCountText), 1)
        ])
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode("span", _hoisted_15, _toDisplayString(_ctx.operationTimeText), 1)
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_FridgeDetailsDrumPicker, {
            minutesLowerLimit: _ctx.minutesLowerLimit,
            minutesUpperLimit: _ctx.minutesUpperLimit,
            initialMinutes: _ctx.initialMinutes,
            isValidSeconds: _ctx.isValidSeconds,
            secondsLowerLimit: _ctx.secondsLowerLimit,
            secondsUpperLimit: _ctx.secondsUpperLimit,
            initialSeconds: _ctx.initialSeconds,
            onSelectTime: _ctx.selectTime
          }, null, 8, ["minutesLowerLimit", "minutesUpperLimit", "initialMinutes", "isValidSeconds", "secondsLowerLimit", "secondsUpperLimit", "initialSeconds", "onSelectTime"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_18, [
      _createVNode("div", {
        class: "fridgesettingstime-page-bottom-button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickStore(...args)))
      }, [
        _createVNode("span", _hoisted_19, _toDisplayString(_ctx.buttonText), 1)
      ])
    ]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"])
  ]))
})